import axios from "axios";

export default class NotifServices {
	constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
    // this.API_LINK = 'http://localhost:8017';
  }

  
  async getNotifications(type) {
    try {
      const notifications = await axios({
        method: "get",
        params: {type},
        url: `${this.API_LINK}/plant/notification`
      });
      
      return notifications;
    } catch (error) {
      throw error.response;
    }
  }
  
  async getNotification(id) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/plant/notification/${id}/`
      });
      return response.data;
    } catch (error) {
      throw error.response;
    }
  }

  async postNotif(notif) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/plant/notification/`,
        data: notif
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async updateNotif(notif, id) {
    try {
      const response = await axios({
        method: "patch",
        url: `${this.API_LINK}/plant/notification/${id}/`,
        data: notif
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async deleteNotification(id) {
    try {
      const response = await axios({
        method: "delete",
        url: `${this.API_LINK}/plant/notification/${id}/`
      });
      return response.data;
    } catch (error) {
      throw error.response;
    }
  }
}
